import {connect} from 'react-redux';
import {getStatus, getResources} from 'redux-resource';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import {readUsers, blessUser, curseUser, sanctifyUser, disgraceUser, deleteUser} from '../../../../redux/actions/users';
import withLoadingIndicator from '../../../common/with-loading-indicator';
import List from './list';

function mapStateToProps(state) {
	const status = getStatus(state, 'users.requests.all.status');
	const users = getResources(state.users, 'all');

	return {
		status,
		users
	};
}

function mapDispatchToProps(dispatch) {
	return {
		readList: () => {
			dispatch(readUsers());
		},
		handleDeleteUser: id => {
			dispatch(deleteUser(id));
		},
		handleConfirmation: (id, value) => {
			if (value) {
				dispatch(blessUser(id));
			} else {
				dispatch(curseUser(id));
			}
		},
		handlePrivilegesChange: (id, value) => {
			if (value) {
				dispatch(sanctifyUser(id));
			} else {
				dispatch(disgraceUser(id));
			}
		}
	};
}

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	lifecycle({
		componentDidMount() {
			this.props.readList();
		}
	}),
	withLoadingIndicator,
	withState('deleteTarget', 'setDeleteTarget', {}),
	/* Do not replace deleteConfirmation with isUndefined check of deletTarget
	 * in open prop of DeleteDialog!
	 * reason: fields of deleteTarget are used in render of
	 * delete confirmation dialog. */
	withState('deleteConfirmation', 'setDeleteConfirmation', false),
	withHandlers({
		handleDeleteItem: props => (id, email) => {
			props.setDeleteTarget({id, name: email, type: 'user'});
			props.setDeleteConfirmation(true);
		},
		handleCancelDelete: props => () => {
			props.setDeleteConfirmation(false);
		},
		handleConfirmDelete: props => () => {
			props.setDeleteConfirmation(false);
			props.handleDeleteUser(props.deleteTarget.id);
		}
	})
);

export default enhance(List);



// WEBPACK FOOTER //
// ./src/client/components/admin/users/list/index.js